module.exports = "/assets/data/e9d550e924cf571c22f6ed33778336f4-BL8.data.json";